import { LoadState } from "../../constants/enums";
import { IOnlineDsaLimit, IOnlineDsaLimitState } from "./OnlineDsaLimit.types";

export const defaultOnlineDsaLimit: IOnlineDsaLimit = {
	online_dsa_activation_id: 0,
	online_dsa_name: "",
	user_id: 0,
	referral_code: "",
	package_id: 0,
	package_name: "",
	total_activations_limit: 0,
	total_activated: 0,
	activation_limit_remaining: 0,
	comment: "",
	 status: 
	 "ACTIVE",
	create_dt: null,
	insert_dt: null,
	leads_uuid: "",
  lead_code: "",
  name: "",
  industry_type: "",
  customer_type: "",
  contact_number: "",
  email: "",
  city: "",
  company_name: "",
  representative_name: "",
  company_outlet_uuid: "",
  company_outlet_name: "",
  representative_email: "",
  representative_contact: "",
  designation: "",
  alternate_contact: "",
  visited_date: new Date().toISOString(),
  function_date: new Date().toISOString(),
  followup_date: new Date().toISOString(),
  followup_time_slot: null,
  next_followup_date: "",
  event_type: "",
  event_time: "",
  event_time_uuid: "",
  number_of_guests: 0,
  preferred_venue: "",
  preferred_venue_uuid: "",
  commercials: [
	{
	  description: [""],
	  value: [""],
	},
  ],
  description: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  handled_by_employee: "",
  handled_by_employee_uuid: "",
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
  whatsapp_status: null,
  remarks: null,
  event_type_uuid: "",
  customer_type_uuid: "",
  source_of_interaction: "",
  proposal: "PROPOSAL_SEND",
};

export const OnlineDsaLimitInitialState: IOnlineDsaLimitState = {
	list: {
		list: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	OnlineDsa: {
		data: defaultOnlineDsaLimit,
		loading: LoadState.NotLoaded,
		error: null,
	},
	 generalHistory: {
		list: [],
		loading: LoadState.NotLoaded,
	  },
	  recordCounts: {
		list: [],
	
		loading: LoadState.NotLoaded,
	  },
};
